import $http from "../../../axios-instance";
import Swal from "sweetalert2";

/**
 * Cargar los productos con beneficios segun empresa.
 *
 * @param {*} commit
 * @param {*} state
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function getProductBenefits({ commit, state }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post(`history-products/list`, state.filterBenefits)
        .then((respose) => {
            commit("listProductBenefits", respose.data.data);
            commit("updateChart", respose.data.data);
        })
        .catch(() => {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "No se pudo cargar los productos.",
            });
        })
        .finally(() => commit("dashboard/load", false, { root: true }));
}

/**
 * Pagina todos los productos con beneficio.
 *
 * @param {*} perPage numero de productos con beneficio por pagina.
 * @author Brandon Torres
 */
export async function setPerPageBenefits({ commit, dispatch }, perPage) {
    commit("setPerPage", parseInt(perPage));
    await dispatch("getProductBenefits");
}

/**
 * Pagina total de productos con beneficio por pagina.
 *
 * @param {*} perPage numero de productos con beneficio por pagina.
 * @author Brandon Torres
 */
export async function setPageBenefits({ commit, dispatch }, perPage) {
    commit("setPage", parseInt(perPage));
    await dispatch("getProductBenefits");
}
